"use strict";

exports.__esModule = true;
exports["default"] = recursiveChildrenMap;

require("core-js/modules/es6.array.map");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function recursiveChildrenMap(children, mapFunction) {
  return _react["default"].Children.map(children, function (child) {
    if (! /*#__PURE__*/_react["default"].isValidElement(child)) {
      return child;
    }

    var reactChild = child;

    if (reactChild.props.children) {
      return mapFunction( /*#__PURE__*/_react["default"].cloneElement(child, {
        children: recursiveChildrenMap(reactChild.props.children, mapFunction)
      }));
    }

    return mapFunction(child);
  });
}